"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var Label = styled_components_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 12px;\n  color: #333333;\n  font-family: Montserrat-Bold;\n  font-weight: bold;\n  padding-left: 10px;\n"], ["\n  font-size: 12px;\n  color: #333333;\n  font-family: Montserrat-Bold;\n  font-weight: bold;\n  padding-left: 10px;\n"])));
exports.default = Label;
var templateObject_1;
//# sourceMappingURL=Label.js.map